// frontend/src/landing/sections/RulesNotBlackboxSection.tsx
import Brand from "../components/Brand";
import Card from "../components/Card";
import Section from "../components/Section";
import { useInViewOnce } from "../components/useInViewOnce";

export default function SolutionSection() {
  const { ref, inView } = useInViewOnce<HTMLDivElement>({
    rootMargin: "0px 0px -15% 0px",
    threshold: 0.2,
  });

  return (
    <Section id="ansatz" eyebrow="Ansatz" title="Was wir anders machen">
      <p className="zg-text">
        <Brand /> ist zu Beginn ein weißes Blatt Papier, auf dem Sie Ihre Organisation abbilden.
        Sie beschreiben dabei Ihre Strukturen, Regeln und Prioritäten in klarer Form.
      </p>
      <p className="zg-text">
        Sie konzentrieren sich auf die Frage: Was ist uns wichtig?
        Im Hintergrund entsteht Ihr Plan.
      </p>
      <p className="zg-text">
        So wird Ihr Regelwerk explizit und Planung moderierbar.
      </p>

      <div className="zg-cards">
        <Card title="Organisation beschreiben">
          <ul className="zg-list">
            <li>Strukturen festhalten</li>
            <li>Regeln formulieren</li>
            <li>Nach Wichtigkeit sortieren</li>
          </ul>
        </Card>

        <Card title="Direkte Rückmeldung">
          <ul className="zg-list">
            <li>Schnell anpassen</li>
            <li>Alternativen vergleichen</li>
            <li>Auf der Meta-Ebene entscheiden</li>
          </ul>
        </Card>

        <Card title="Komplexität auslagern">
          <ul className="zg-list">
            <li>Kombinatorik im Hintergrund</li>
            <li>Rechenleistung nutzen</li>
            <li>Mensch entscheidet, <Brand /> führt aus</li>
          </ul>
        </Card>
      </div>
      <p className="zg-footnote">
        Der Plan ist nur das Ergebnis. Das Regelwerk ist die eigentliche Grundlage.
      </p>
    </Section>
  );
}